import Axios from 'axios'
import server from 'util/Server'
import { RecursoCreateRequest, ActualizarRecursoRequest } from '../interfaces/ConfiguracionRecursos.interfaces'
import { getSelectEDS } from 'app/vistas/Reportes/servicios/serviciosSelect'
import { getRegionalService } from 'services/selectServices/services'
import { getEmpresas } from 'services/Importadores/services'
import { getRegionales } from 'components/filtros/FiltrosEds/servicios'

export const GetListadoRecursos = (empresaId?: number | string) =>
    Axios.get(`${server.host!}8014/api/v1/configuracion-recursos/listado`, {
        params: empresaId ? { empresa_id: empresaId } : undefined,
        headers: { Authorization: server.obtenerToken() },
    })

export const GetDetalleRecurso = (recursoId: number) =>
    Axios.get(`${server.host!}8014/api/v1/configuracion-recursos/detalle`, {
        params: { recurso_id: recursoId },
        headers: { Authorization: server.obtenerToken() },
    })

/**
 * Un único endpoint hace todo: sube los archivos al storage y crea un recurso
 * por cada uno en las estaciones seleccionadas. Por eso el request viaja como
 * multipart/form-data y no lleva `url` (la resuelve el backend al guardar).
 */
export const CrearRecurso = ({ empresa_ids, tipo_id, nombre, estado_id, archivos }: RecursoCreateRequest) => {
    const formData = new FormData()

    // Los campos repetidos son los que gin mapea a []int64 en empresa_ids.
    empresa_ids.forEach((empresaId) => formData.append('empresa_ids', String(empresaId)))
    formData.append('tipo_id', String(tipo_id))
    formData.append('nombre', nombre)
    if (estado_id !== undefined) formData.append('estado_id', String(estado_id))
    archivos.forEach((archivo) => formData.append('archivos', archivo))

    return Axios.post(`${server.host!}8014/api/v1/configuracion-recursos/crear`, formData, {
        headers: {
            Authorization: server.obtenerToken(),
            'Content-Type': 'multipart/form-data',
        },
    })
}

/**
 * Edición del recurso, también en un solo endpoint multipart: el `archivo` es
 * opcional y solo se envía cuando se reemplaza el actual (el backend lo sube,
 * actualiza la url y borra el archivo anterior del storage). Si no se envía
 * archivo se conserva la `url` que ya tenía.
 */
export const EditarRecurso = ({ id, tipo_id, nombre, url, estado_id, archivo }: ActualizarRecursoRequest) => {
    const formData = new FormData()

    formData.append('id', String(id))
    formData.append('tipo_id', String(tipo_id))
    formData.append('nombre', nombre)
    formData.append('url', url ?? '')
    formData.append('estado_id', String(estado_id))
    if (archivo) formData.append('archivo', archivo)

    return Axios.put(`${server.host!}8014/api/v1/configuracion-recursos/editar`, formData, {
        headers: {
            Authorization: server.obtenerToken(),
            'Content-Type': 'multipart/form-data',
        },
    })
}

export const CambiarEstadoRecurso = (payload: { recurso_id: number; estado_id: number }) =>
    Axios.post(`${server.host!}8014/api/v1/configuracion-recursos/estado`, payload, {
        headers: { Authorization: server.obtenerToken() },
    })

// Catálogo de tipos de recurso (imagen, video, etc.) -> autoservicio.fnc_recursos_tipos_get()
export const GetTiposRecurso = () =>
    Axios.get(`${server.host!}8014/api/v1/configuracion-recursos/tipos`, {
        headers: { Authorization: server.obtenerToken() },
    })

export const getEdsByUserLogged = (empresas: string) => getEmpresas(empresas)

export const getRegionalesByNegocio = (negocio_id: number) => getRegionalService(negocio_id)


export const GetEmpresasByRegionales = (regionales: number[], organizaciones: number[]) =>
    Axios.get(`${server.host!}8014/api/v1/empresa/by-regionales`, {
        params: {
            regionales: regionales.join(','),
            organizaciones: organizaciones.join(','),
        },
        headers: { Authorization: server.obtenerToken() },
    })

/**
 * Estaciones de una organización (sin filtrar por regional). Es el mismo
 * endpoint que usa el filtro de organización del listado
 * (useGenericInfo.getEmpresasByOrganizacion); acá se consume directo para poder
 * autoseleccionar las estaciones con la respuesta en mano.
 */
export const GetEmpresasByOrganizacion = (organizacion_id: number) =>
    Axios.get(
        `${server.host}${server.puerto_integracion_sap}/api/v1/organization/organizationCompany/${organizacion_id}`,
        { headers: { Authorization: server.obtenerToken() } }
    )

/**
 * Subida suelta de un archivo. La creación ya no la usa (va todo en /crear);
 * queda para la edición, donde el recurso ya existe y solo se reemplaza la url.
 */
export const SubirArchivoRecurso = (file: File) => {
    const formData = new FormData()
    formData.append('archivo', file)
 
    return Axios.post(`${server.host!}8014/api/v1/files/upload`, formData, {
        headers: {
            Authorization: server.obtenerToken(),
            'Content-Type': 'multipart/form-data',
        },
    })
}